import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";

const numberWithCommas = n =>
  n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const ModalExhibit1 = ({ initialDemand, demandGrowthRate, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 1 - Unmet Demand & Growth Projections</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Description</th>
          <th>Mobile Segment</th>
          <th>Auto Segment</th>
        </tr>
        <tr>
          <td>Year 1 Annual unmet demand</td>
          <td>{numberWithCommas(initialDemand.mobile)} units</td>
          <td>{numberWithCommas(initialDemand.auto)} units</td>
        </tr>
        <tr className="grey">
          <td colSpan="3">Expected annual growth percentage</td>
        </tr>
        {demandGrowthRate.map(demandGrowthRateValue => (
          <tr key={demandGrowthRateValue.id}>
            <td>Year {demandGrowthRateValue.round_number + 1}</td>
            <td>{demandGrowthRateValue.mobile * 100}%</td>
            <td>{demandGrowthRateValue.auto * 100}%</td>
          </tr>
        ))}
      </tbody>
    </Styled.ModalTable>
  </CustomModal>
);

export default ModalExhibit1;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit1.js